import { FileText, Zap } from 'lucide-react'
import { ENTITY_ICON_COMPONENTS } from '@/components/neo4j/cytoscape/entity-icons'
import type { BridgeInsight } from '@/services/api/graph'

export interface BridgeRowProps {
  bridge: BridgeInsight
  onClick?: () => void
  onOpenDocument?: () => void
}

export function BridgeRow({ bridge, onClick, onOpenDocument }: BridgeRowProps) {
  const IconA = ENTITY_ICON_COMPONENTS[bridge.entity_a_type]
  const IconB = ENTITY_ICON_COMPONENTS[bridge.entity_b_type]
  return (
    <div
      className="flex items-center gap-2 rounded-md px-2 py-1.5 text-xs bg-[var(--muted)]/30 hover:bg-[var(--muted)]/60 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)] max-md:flex-wrap max-md:gap-y-1"
      role="button"
      tabIndex={0}
      title={bridge.document_title ? `via: ${bridge.document_title}` : undefined}
      onClick={onClick}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick?.()
        }
      }}
    >
      {IconA ? (
        <IconA className="size-3.5 text-[var(--muted-foreground)] shrink-0" />
      ) : (
        <span className="size-3.5 shrink-0" />
      )}
      <span className="truncate text-[var(--foreground)] max-md:basis-[calc(100%-1.5rem)]">
        {bridge.entity_a_name}
      </span>
      <div className="flex-shrink-0 flex items-center gap-1 text-[var(--muted-foreground)]">
        <div className="h-px w-3 bg-[var(--border)]" />
        <Zap className="size-3" />
        <div className="h-px w-3 bg-[var(--border)]" />
      </div>
      {IconB ? (
        <IconB className="size-3.5 text-[var(--muted-foreground)] shrink-0" />
      ) : (
        <span className="size-3.5 shrink-0" />
      )}
      <span className="truncate text-[var(--foreground)] max-md:min-w-0 max-md:flex-1 max-md:basis-0">
        {bridge.entity_b_name}
      </span>
      {bridge.document_id && onOpenDocument && (
        <button
          type="button"
          onClick={e => {
            e.stopPropagation()
            onOpenDocument()
          }}
          className="ml-auto inline-flex items-center justify-center size-5 rounded-md text-[var(--muted-foreground)] hover:text-[var(--foreground)] hover:bg-[var(--muted)] shrink-0 max-md:size-8"
          title={bridge.document_title ?? 'Open source document'}
        >
          <FileText className="size-3" />
        </button>
      )}
      {!bridge.document_id && (
        <FileText className="size-3 text-[var(--muted-foreground)] ml-auto shrink-0 opacity-40" />
      )}
    </div>
  )
}
